<!-- ══════════════════════════════════════════════════
     HERO — Mensaje + formulario de clave catastral
══════════════════════════════════════════════════ -->
<section class="hero-section">
    <div class="container">
        <div class="hero-grid">

            <!-- Mensaje -->
            <div class="hero-mensaje">
                <span class="section-badge">Impuesto predial</span>
                <h1>Paga tu predial en línea, <span>fácil y seguro</span></h1>
                <p class="hero-mensaje__lead">
                    Consulta el adeudo de tu predio con tu clave catastral y págalo con tarjeta de crédito o débito, sin filas.
                </p>

                <ol class="pasos">
                    <li>
                        <span class="pasos__num">1</span>
                        <div>
                            <strong>Ingresa tu clave catastral</strong>
                            <span>La encuentras en tu recibo de predial.</span>
                        </div>
                    </li>
                    <li>
                        <span class="pasos__num">2</span>
                        <div>
                            <strong>Revisa tu adeudo</strong>
                            <span>Elige hasta qué periodo quieres pagar.</span>
                        </div>
                    </li>
                    <li>
                        <span class="pasos__num">3</span>
                        <div>
                            <strong>Paga y descarga tu recibo</strong>
                            <span>Al instante, con validez oficial.</span>
                        </div>
                    </li>
                </ol>

                <div class="hero-confianza">
                    <span><i class="fa-solid fa-shield-halved" aria-hidden="true"></i> Pago con 3-D Secure</span>
                    <span><i class="fa-regular fa-credit-card" aria-hidden="true"></i> Crédito y débito</span>
                    <span><i class="fa-solid fa-file-invoice" aria-hidden="true"></i> Recibo oficial</span>
                </div>
            </div>

            <!-- Formulario -->
            <div class="search-card">
                <div class="search-card__header">
                    <h2>Consulta tu adeudo</h2>
                    <p>Escribe tu clave catastral. Si la copias completa, puedes pegarla en cualquier campo.</p>
                </div>

                <div class="catastral-form">
                    <div class="catastral-inputs" (paste)="PegarClave($event)">
                        <div class="catastral-field catastral-field--fijo">
                            <label for="mun">MUN</label>
                            <input id="mun" class="form-control" type="tel" [readonly]="true"
                                (keypress)="numberOnly($event)" maxlength="3"
                                [(ngModel)]="cve_catast.mun" aria-label="Municipio">
                        </div>
                        <div class="catastral-field">
                            <label for="pob">POB</label>
                            <input #pob id="pob" class="form-control" type="tel" placeholder="000" inputmode="numeric"
                                (keypress)="numberOnly($event)" maxlength="3"
                                (focus)="pob.select()" [(ngModel)]="cve_catast.pob" aria-label="Población">
                        </div>
                        <div class="catastral-field">
                            <label for="cua">CUA</label>
                            <input #cua id="cua" class="form-control" type="tel" placeholder="000" inputmode="numeric"
                                (keypress)="numberOnly($event)" maxlength="3"
                                (keydown.backspace)="prevField($event)"
                                (focus)="cua.select()" [(ngModel)]="cve_catast.cua" aria-label="Cuartel">
                        </div>
                        <div class="catastral-field">
                            <label for="man">MAN</label>
                            <input #man id="man" class="form-control" type="tel" placeholder="000" inputmode="numeric"
                                (keypress)="numberOnly($event)" maxlength="3"
                                (keydown.backspace)="prevField($event)"
                                (focus)="man.select()" [(ngModel)]="cve_catast.man" aria-label="Manzana">
                        </div>
                        <div class="catastral-field">
                            <label for="pre">PRE</label>
                            <input #pre id="pre" class="form-control" type="tel" placeholder="000" inputmode="numeric"
                                (keypress)="numberOnly($event)" maxlength="3"
                                (keydown.backspace)="prevField($event)"
                                (focus)="pre.select()" [(ngModel)]="cve_catast.pre" aria-label="Predio">
                        </div>
                        <div class="catastral-field">
                            <label for="uni">UNI</label>
                            <input #uni id="uni" class="form-control" type="tel" placeholder="000" inputmode="numeric"
                                (keypress)="numberOnly($event)" maxlength="3"
                                (keydown.backspace)="prevField($event)"
                                (focus)="uni.select()" [(ngModel)]="cve_catast.uni"
                                (keydown.enter)="SubmitUni()" aria-label="Unidad">
                        </div>
                    </div>

                    <div class="clave-preview" [class.clave-preview--lista]="claveCompleta">
                        <span class="clave-preview__label">Clave</span>
                        <span class="clave-preview__valor">{{ claveFormateada }}</span>
                        <i *ngIf="claveCompleta" class="fa-solid fa-circle-check" aria-hidden="true"></i>
                    </div>

                    <p class="mensaje-error" *ngIf="mensajeError" role="alert">
                        <i class="fas fa-exclamation-circle mr-1"></i>{{mensajeError}}
                    </p>

                    <button id="btnconsultar" type="button" (click)="SubmitUni()" [disabled]="!claveCompleta">
                        <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i> Consultar adeudo
                    </button>

                    <button type="button" class="link-ayuda" data-toggle="modal" data-target="#clave_catastral">
                        <i class="fa-regular fa-circle-question" aria-hidden="true"></i> ¿Dónde encuentro mi clave catastral?
                    </button>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- ══════════════════════════════════════════════════
     AYUDA — Guías ilustradas
══════════════════════════════════════════════════ -->
<section class="info-section" id="informacion">
    <div class="container">
        <div class="info-section__header">
            <h2>¿Necesitas ayuda?</h2>
            <p>Consulta nuestras guías rápidas antes de pagar.</p>
        </div>

        <div class="info-cards-grid">

            <button type="button" class="info-card" data-toggle="modal" data-target="#ayuda_pago">
                <span class="info-card__icon"><i class="fa-regular fa-credit-card" aria-hidden="true"></i></span>
                <span class="info-card__body">
                    <strong>Proceso de pago</strong>
                    <span>¿Cómo realizo un pago en línea?</span>
                </span>
                <i class="fa-solid fa-arrow-right info-card__arrow" aria-hidden="true"></i>
            </button>

            <button type="button" class="info-card" data-toggle="modal" data-target="#clave_catastral">
                <span class="info-card__icon"><i class="fa-solid fa-map-location-dot" aria-hidden="true"></i></span>
                <span class="info-card__body">
                    <strong>Clave catastral</strong>
                    <span>Ubícala en tu recibo oficial.</span>
                </span>
                <i class="fa-solid fa-arrow-right info-card__arrow" aria-hidden="true"></i>
            </button>

            <button type="button" class="info-card" data-toggle="modal" data-target="#consultar_adeudo">
                <span class="info-card__icon"><i class="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i></span>
                <span class="info-card__body">
                    <strong>Consulta tu adeudo</strong>
                    <span>Conoce el estado de tu cuenta predial.</span>
                </span>
                <i class="fa-solid fa-arrow-right info-card__arrow" aria-hidden="true"></i>
            </button>

        </div>
    </div>
</section>

<!-- ══════════════════════════════════════════════════
     MODALES
══════════════════════════════════════════════════ -->
<div class="dialog">
    <div class="modal fade" id="ayuda_pago" tabindex="-1" role="dialog">
        <div class="modal-ayuda modal-dialog modal-dialog-centered">
            <div class="modal-content modal-ayuda__content" role="document">
                <button class="modal-ayuda__close" data-dismiss="modal" aria-label="Cerrar">
                    <i class="fas fa-times"></i>
                </button>
                <img src="{{img_ayuda_1}}" alt="Guía proceso de pago" class="modal-ayuda__img">
            </div>
        </div>
    </div>
</div>

<div class="dialog">
    <div class="modal fade" id="clave_catastral" tabindex="-1" role="dialog">
        <div class="modal-ayuda modal-dialog modal-dialog-centered">
            <div class="modal-content modal-ayuda__content" role="document">
                <button class="modal-ayuda__close" data-dismiss="modal" aria-label="Cerrar">
                    <i class="fas fa-times"></i>
                </button>
                <img src="{{img_ayuda_2}}" alt="Guía clave catastral" class="modal-ayuda__img">
            </div>
        </div>
    </div>
</div>

<div class="dialog">
    <div class="modal fade" id="consultar_adeudo" tabindex="-1" role="dialog">
        <div class="modal-ayuda modal-dialog modal-dialog-centered">
            <div class="modal-content modal-ayuda__content" role="document">
                <button class="modal-ayuda__close" data-dismiss="modal" aria-label="Cerrar">
                    <i class="fas fa-times"></i>
                </button>
                <img src="{{img_ayuda_3}}" alt="Guía consulta adeudo" class="modal-ayuda__img">
            </div>
        </div>
    </div>
</div>
